import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { deleteComment } from '../services/budgetCommentsService'
import { budgetCommentsKeys } from './budgetCommentsQueryKeys'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'

export const useDeleteComment = () => {
  const queryClient = useQueryClient()
  const companyId = useSelector(contextCompanyIdSelector)
  const { budgetingScenario } = useSelector(filtersSelector)

  return useMutation({
    mutationFn: async (commentId: number) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }

      return deleteComment({
        companyId,
        commentId,
        budgetingScenarioId: budgetingScenario?.id
      })
    },

    onSuccess: () => {
      // Invalidate comments queries to refetch data
      queryClient.invalidateQueries({
        queryKey: budgetCommentsKeys.comments()
      })
    },

    onError: error => {
      console.error('Error deleting comment:', error)
    }
  })
}
